import { useContext } from 'react';
import { useParams } from 'react-router-dom';

// import AbsoluteBgVdo from '../../assets/videos/login-bg-vdo.mp4';
import AbsoluteBgImageDark from '../../assets/images/register/register-bg-dark.jpg';
import AbsoluteBgImage from '../../assets/images/register/register-bg.png';
import ThemeContext from '../../contexts/theme-context/ThemeContext';

import EmailVerification from './components/EmailVerification';
import ForgotPassword from './components/ForgotPassword';
import InitialPasswordReset from './components/InitialPasswordReset';
import LoginComponent from './components/Login';
import PasswordReset from './components/PasswordReset';
import PasswordResetOTP from './components/PasswordResetOTP';
import PhoneNumberVerification from './components/PhoneNumberVerification';

/**
 * Login page
 */
function Login() {
  const { theme } = useContext(ThemeContext);
  const { page, subpage } = useParams<Record<string, string>>();
  /**
   * getBgImage
   */
  const getBgImage = () => {
    return theme === 'light' ? AbsoluteBgImage : AbsoluteBgImageDark;
  };

  return (
    <div className="login-wrap">
      {(() => {
        let pageContent;
        if (page === 'credentials') {
          pageContent = <LoginComponent />;
        } else if (page === 'email-verification') {
          pageContent = <EmailVerification />;
        } else if (page === 'phone-number-verification') {
          pageContent = <PhoneNumberVerification />;
        } else if (page === 'forgot-password') {
          pageContent = <ForgotPassword />;
        } else if (page === 'forgot-password-otp-verification') {
          pageContent = <PasswordResetOTP />;
        } else if (page === 'reset-password') {
          pageContent = <PasswordReset token={subpage} />;
        } else if (page === 'reset-initial-password') {
          pageContent = <InitialPasswordReset />;
        }

        return pageContent;
      })()}

      <img src={getBgImage()} alt="" className="absolute-bg-image" />
      {/* <video controls={false} autoPlay loop muted className="absolute-bg-image">
        <source src={AbsoluteBgVdo} type="video/mp4" />
        <track src="path/to/captions.vtt" kind="captions" label="English captions" default />
        Your browser does not support the video tag.
      </video> */}
    </div>
  );
}

export default Login;
